function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 13.5,
  y1: 10.5,
  x2: 6,
  y2: 3,
  fill: "none",
  stroke: "#afafaf",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  x1: 13.5,
  y1: 9.5,
  x2: 6,
  y2: 17,
  fill: "none",
  stroke: "#afafaf",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}));

var SvgRightBracket = function SvgRightBracket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightBracket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-bracket.0a660e96.svg";
export { ForwardRef as ReactComponent };